import React from 'react';
import { VideoElement } from 'features/document/constants';
import { Container, IframeElement, Wrapper } from './VideoPlayer.styled';
import { VIDEO_URL_LENGTH } from './VideoConstants';
interface Props {
  currentElement: VideoElement;
}

export default function VideoPlayer({ currentElement }: Props) {
  const { width, height, justifyContent } = currentElement.style;

  function getId(url: string) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\\&v=)([^#\\&\\?]*).*/;
    const match = url.match(regExp);

    if (match && match[2].length == VIDEO_URL_LENGTH) {
      return match[2];
    }
    return null;
  }
  const widthCustom = Number(parseInt(width, 10)) + 250;
  return (
    <Container align={justifyContent}>
      <Wrapper height={height} width={widthCustom.toString()}>
        <IframeElement src={`//www.youtube.com/embed/${getId(currentElement.content.src)}`} allowFullScreen />
      </Wrapper>
    </Container>
  );
}
